/* eslint-disable max-classes-per-file */
import { Expose, Transform, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEnum, IsNumber, IsObject, IsOptional, IsString } from 'class-validator';
import CreatedInfo from './created-info';
import ServiceType from './service-type.entity';
import UpdatedInfo from './updated-info';
import ReservationScope from './reservation-scope.type';

export class ServiceOpenHourContent {
  @IsNumber()
  readonly duration: number;

  @IsNumber()
  @Expose({ name: 'start_at' })
  readonly startAt: number;

  constructor(init: ServiceOpenHourContent);

  constructor(init?: ServiceOpenHourContent) {
    this.duration = init?.duration!;
    this.startAt = init?.startAt!;
  }
}

export class ServiceOpenHour {
  @IsArray()
  @Type(() => ServiceOpenHourContent)
  @IsOptional()
  readonly sunday?: ServiceOpenHourContent[];

  @IsArray()
  @Type(() => ServiceOpenHourContent)
  @IsOptional()
  readonly monday?: ServiceOpenHourContent[];

  @IsArray()
  @Type(() => ServiceOpenHourContent)
  @IsOptional()
  readonly tuesday?: ServiceOpenHourContent[];

  @IsArray()
  @Type(() => ServiceOpenHourContent)
  @IsOptional()
  readonly wednesday?: ServiceOpenHourContent[];

  @IsArray()
  @Type(() => ServiceOpenHourContent)
  @IsOptional()
  readonly thursday?: ServiceOpenHourContent[];

  @IsArray()
  @Type(() => ServiceOpenHourContent)
  @IsOptional()
  readonly friday?: ServiceOpenHourContent[];

  @IsArray()
  @Type(() => ServiceOpenHourContent)
  @IsOptional()
  readonly saturday?: ServiceOpenHourContent[];

  constructor(init: ServiceOpenHour);

  constructor(init?: ServiceOpenHour) {
    this.sunday = init?.sunday;
    this.monday = init?.monday;
    this.tuesday = init?.tuesday;
    this.wednesday = init?.wednesday;
    this.thursday = init?.thursday;
    this.friday = init?.friday;
    this.saturday = init?.saturday;
  }
}

export class Service {
  @IsString()
  readonly id: string;

  @IsString()
  readonly label: string;

  @IsString()
  @Expose({ name: 'image_url' })
  readonly imageUrl?: string | null;

  @IsString()
  @IsOptional()
  readonly instructions?: string;

  @Expose({ name: 'max_reservations_by_unit' })
  @IsOptional()
  @IsNumber()
  readonly maxReservationsByUnit?: number;


  @Expose({ name: 'max_reservations_by_dweller' })
  @IsOptional()
  @IsNumber()
  readonly maxReservationsByDweller?: number;

  @Expose({ name: 'reservation_scope' })
  @IsEnum(ReservationScope)
  @IsOptional()
  readonly reservationScope?: ReservationScope;

  @Expose({ name: 'max_simultaneos_reservations' })
  @IsNumber()
  @IsOptional()
  /** Garante que o serviço tenha no max 1 reserva simultanea se nao setado */
  @Transform(({ value }) => value ?? 1, { toClassOnly: true })
  readonly maxSimultaneosReservations: number;

  @Expose({ name: 'disable_sequential_reservations' })
  @IsBoolean()
  @IsOptional()
  /** Garante que a reserva sequencial é ativa se nao setado */
  @Transform(({ value }) => value ?? false, { toClassOnly: true })
  readonly disableSequentialReservations: boolean;

  @Expose({ name: 'enable_exclusive_reservations' })
  @IsBoolean()
  @IsOptional()
  /** Garante que a reserva exclusiva é inativa se nao setado  */
  @Transform(({ value }) => value ?? false, { toClassOnly: true })
  readonly enableExclusiveReservations: boolean;

  @Expose({ name: 'is_enabled' })
  @IsBoolean()
  @IsOptional()
  /** Garante que a serviço esta ativa se nao setado */
  @Transform(({ value }) => value ?? true, { toClassOnly: true })
  readonly isEnabled: boolean;

  @Expose({ name: 'open_hours' })
  @IsObject()
  @Type(() => ServiceOpenHour)
  readonly openHours: ServiceOpenHour;

  @IsNumber()
  @Expose({ name: 'reservation_duration' })
  readonly reservationDuration: number;

  @IsNumber()
  @IsOptional()
  readonly price?: number | null;

  @IsEnum(ServiceType)
  readonly type: ServiceType;

  @IsOptional()
  @IsObject()
  readonly created?: CreatedInfo;

  @IsOptional()
  @IsObject()
  readonly updated?: UpdatedInfo;

  constructor(init?: Service | Partial<Service>) {
    this.id = init?.id!;
    this.label = init?.label!;
    this.imageUrl = init?.imageUrl!;
    this.instructions = init?.instructions!;
    this.reservationScope = init?.reservationScope;
    this.maxReservationsByUnit = init?.maxReservationsByUnit;
    this.maxReservationsByDweller = init?.maxReservationsByDweller;
    this.maxSimultaneosReservations = init?.maxSimultaneosReservations!;
    this.disableSequentialReservations = init?.disableSequentialReservations!;
    this.enableExclusiveReservations = init?.enableExclusiveReservations!;
    this.isEnabled = init?.isEnabled!;
    this.openHours = init?.openHours!;
    this.reservationDuration = init?.reservationDuration!;
    this.price = init?.price;
    this.type = init?.type!;

    this.created = init?.created ? new CreatedInfo(init?.created!) : undefined;
    this.updated = init?.updated ? new UpdatedInfo(init?.updated!) : undefined;
  }
}

export default Service;
